import * as Actions from 'reducks/storeDeliveryFee/actions'
import { initialState } from 'reducks/reduxStore/initialState'

export const StoreDeliveryFeeReducer = (state = initialState.storeDeliveryFee, action: any) => {
  switch (action.type) {
    case Actions.CONFIRM_STORE_DELIVERY_FEES:
      return {
        storeDeliveryFees: [...action.payload],
      }
    case Actions.FETCH_STORE_DELIVERY_FEES:
      return {
        storeDeliveryFees: [...action.payload],
      }
    case Actions.INIT_STORE_DELIVERY_FEES:
      return {
        ...initialState.storeDeliveryFee,
      }
    default:
      return state
  }
}
